'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pixi = require('pixi.js');

var PIXI = _interopRequireWildcard(_pixi);

var _gsap = require('gsap');

var _OnScreen = require('lib/OnScreen');

var _OnScreen2 = _interopRequireDefault(_OnScreen);

var _Network = require('components/Technical/Network');

var _Network2 = _interopRequireDefault(_Network);

var _Control = require('components/Technical/Control');

var _Control2 = _interopRequireDefault(_Control);

var _Light = require('components/Technical/Light');

var _Light2 = _interopRequireDefault(_Light);

var _Solutions = require('components/Technical/Solutions');

var _Solutions2 = _interopRequireDefault(_Solutions);

var _media = require('./media.css');

var _media2 = _interopRequireDefault(_media);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// const Media = ({ ltr, num, title, copy, img }) => {
var Media = function (_Component) {
  _inherits(Media, _Component);

  function Media() {
    _classCallCheck(this, Media);

    var _this = _possibleConstructorReturn(this, (Media.__proto__ || Object.getPrototypeOf(Media)).call(this));

    _this.state = {
      imgW: 700,
      imgH: 700,
      width: 0,
      inView: false
    };
    return _this;
  }

  _createClass(Media, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var isCanvas = this.props.isCanvas;

      this.mainRAF = null;
      this.imgRAF = null;
      this.in = _OnScreen2.default.in(this.refs.block, this.showBlock.bind(this), false);

      this.setState({
        imgW: 1000,
        imgH: 1000,
        width: window.innerWidth
      }, function () {
        if (_this2.state.width > 1024) {
          if (isCanvas) {
            _this2.initCanvas();
          }
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unMountCanvas();
      _OnScreen2.default.unsubscribe(this.in);

      window.audioCTXT.suspend();
    }
  }, {
    key: 'showBlock',
    value: function showBlock() {
      this.setState({ inView: true });
    }
  }, {
    key: 'initCanvas',
    value: function initCanvas() {
      this.initImagePixi();
      this.initPixi();
      this.initAudioAPI();
    }
  }, {
    key: 'unMountCanvas',
    value: function unMountCanvas() {
      if (this.stage) {
        this.stage.destroy(true);
        this.stage = null;
        this.canvas.removeChild(this.renderer.view);
        this.renderer.destroy(true);
        this.renderer = null;
      }

      if (this.mainRAF) {
        window.cancelAnimationFrame(this.mainRAF);
        this.mainRAF = null;
      }

      if (this.imgStage) {
        this.imgStage.destroy(true);
        this.imgStage = null;
        this.imgCanvas.removeChild(this.imgRenderer.view);
        this.imgRenderer.destroy(true);
        this.imgRenderer = null;
      }

      if (this.imgRAF) {
        window.cancelAnimationFrame(this.imgRAF);
        this.imgRAF = null;
      }
    }
  }, {
    key: 'initAudioAPI',
    value: function initAudioAPI() {
      function BufferLoader(context, urlList, callback) {
        this.context = context;
        this.urlList = urlList;
        this.onload = callback;
        this.bufferList = [];
        this.loadCount = 0;
      }

      window.audioCTXT.resume();

      BufferLoader.prototype.loadBuffer = function (url, index) {
        // Load buffer asynchronously
        var request = new XMLHttpRequest();
        request.open('GET', url, true);
        request.responseType = 'arraybuffer';

        var loader = this;

        request.onload = function () {
          // Asynchronously decode the audio file data in request.response
          loader.context.decodeAudioData(request.response, function (buffer) {
            if (!buffer) {
              console.log('error decoding file data: ' + url);
              return;
            }
            loader.bufferList[index] = buffer;
            if (++loader.loadCount === loader.urlList.length) {
              loader.onload(loader.bufferList);
            }
          }, function (error) {
            console.error('decodeAudioData error', error);
          });
        };

        request.onerror = function () {
          console.log('BufferLoader: XHR error');
        };

        request.send();
      };

      BufferLoader.prototype.load = function () {
        for (var i = 0; i < this.urlList.length; ++i) {
          this.loadBuffer(this.urlList[i], i);
        }
      };
      var context = void 0;
      var bufferLoader = void 0;

      context = window.audioCTXT;

      bufferLoader = new BufferLoader(context, ['/audio/3.wav', '/audio/4.wav', '/audio/9.wav', '/audio/11.wav', '/audio/2.wav', '/audio/12.wav'], finishedLoading.bind(this));

      bufferLoader.load();

      function finishedLoading(bufferList) {
        this.setState({
          context: context,
          bufferLoader: bufferLoader,
          bufferList: bufferList
        });
      }
    }
  }, {
    key: 'getRandom',
    value: function getRandom(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
  }, {
    key: 'playSound',
    value: function playSound(type) {
      var _state = this.state,
          context = _state.context,
          bufferList = _state.bufferList;

      var source1 = context.createBufferSource();

      if (type.isCirclesBig) {
        var random = this.getRandom(0, 1);
        source1.buffer = bufferList[random];
      } else if (type.isPulse) {
        var _random = this.getRandom(2, 3);
        source1.buffer = bufferList[_random];
      } else {
        var _random2 = this.getRandom(4, 5);
        source1.buffer = bufferList[_random2];
      }

      source1.connect(context.destination);
      source1.start(0);
    }
  }, {
    key: 'initCircles',
    value: function initCircles(isCirclesBig) {
      var _this3 = this;

      var stage = this.stage;
      var w = this.state.imgW;
      var h = this.state.imgH;
      var circlesContainer = new PIXI.Container();

      var radius = isCirclesBig ? 24 : 4;
      var circles = [{ limit: 1, radius: 0 }, { limit: 6, radius: radius * 3.5 * (!isCirclesBig ? 5.8 : 1) }, { limit: 12, radius: radius * 7 * (!isCirclesBig ? 5.8 : 1) }, { limit: 20, radius: radius * 10.5 * (!isCirclesBig ? 5.8 : 1) }, { limit: 24, radius: radius * 14 * (!isCirclesBig ? 5.8 : 1) }, { limit: 32, radius: radius * 17.5 * (!isCirclesBig ? 5.8 : 1) }];

      for (var i = 0; i < circles.length; i++) {
        for (var ii = 0; ii < circles[i].limit; ii++) {
          var circle = new PIXI.Graphics();
          var limit = circles[i].limit;
          var bigRadius = circles[i].radius;

          var theta = Math.PI * 2 / limit;
          var angle = theta * ii;

          var x = bigRadius * Math.cos(angle) + w / 2;
          var y = bigRadius * Math.sin(angle) + h / 2;

          circle.lineStyle(2, 0xE32365, 1);
          circle.beginFill(0xE32365, 0);
          circle.drawCircle(0, 0, radius);
          circle.endFill();
          circle.position.set(x, y);
          circle.anchor = { x: 0.5, y: 0.5 };
          circle.interactive = true;
          circle.buttonMode = true;
          circle.on('mouseover', this.mouseOverCircle.bind(this));
          circle.on('mouseout', this.mouseLeaveCircle.bind(this));
          circle.on('mousedown', function (e) {
            _this3.mouseClickCircle(e, isCirclesBig);
          });

          circlesContainer.addChild(circle);
        }
      }

      stage.addChild(circlesContainer);

      var rectangle = PIXI.Sprite.fromImage('/images/rectangle.png');
      rectangle.width = w;
      rectangle.height = h;
      rectangle.blendMode = PIXI.BLEND_MODES.MULTIPLY;
      rectangle.interactive = false;
      rectangle.hitArea = new PIXI.Rectangle(0, 0, 0, 0);
      // stage.addChild(rectangle)
    }
  }, {
    key: 'initPulse',
    value: function initPulse() {
      var stage = this.stage;
      var w = this.state.imgW;
      var h = this.state.imgH;
      var limit = 4;
      var baseRadius = 85;
      var radiuses = [baseRadius, baseRadius * 2, baseRadius * 3, baseRadius * 4, baseRadius * 5];

      for (var i = limit; i >= 0; i--) {
        var circle = new PIXI.Graphics();
        circle.lineStyle(2, 0xE32365, 1);
        circle.beginFill(0xE32365, 0);
        circle.drawCircle(0, 0, radiuses[i]);
        circle.position.set(w / 2.1, h / 1.95);
        circle.anchor = { x: 0.5, y: 0.5 };
        circle.interactive = true;
        circle.buttonMode = true;
        circle.on('mouseover', this.mouseOverCircle.bind(this));
        circle.on('mouseout', this.mouseLeaveCircle.bind(this));
        circle.on('mousedown', this.mouseClickCircle.bind(this));
        circle.endFill();

        stage.addChild(circle);
      }

      var rectangle = PIXI.Sprite.fromImage('/images/rectangle.png');
      rectangle.width = w;
      rectangle.height = h;
      rectangle.blendMode = PIXI.BLEND_MODES.MULTIPLY;
      rectangle.interactive = false;
      rectangle.hitArea = new PIXI.Rectangle(0, 0, 0, 0);
      // stage.addChild(rectangle)
    }
  }, {
    key: 'mouseOverCircle',
    value: function mouseOverCircle(eventData) {
      var isPulse = this.props.isPulse;

      var target = eventData.target;
      var scale = target.scale;
      var targetScale = isPulse ? 1.05 : 1.1;

      _gsap.TweenLite.to(scale, 0.3, {
        x: targetScale,
        y: targetScale
      });
    }
  }, {
    key: 'mouseLeaveCircle',
    value: function mouseLeaveCircle(eventData) {
      var target = eventData.currentTarget;
      var scale = target.scale;

      _gsap.TweenLite.to(scale, 0.3, {
        x: 1,
        y: 1
      });
    }
  }, {
    key: 'mouseClickCircle',
    value: function mouseClickCircle(eventData, isCirclesBig) {
      var _props = this.props,
          isPulse = _props.isPulse,
          isCircles = _props.isCircles;

      var displacementSprite = this.displacementSprite;
      var scale = displacementSprite.scale;
      var targetScale = isPulse ? 6 : 4;

      this.playSound({
        isCirclesBig: isCirclesBig, isPulse: isPulse, isCircles: isCircles
      });

      if (isCircles) {
        _gsap.TweenLite.to(scale, 0.1, {
          x: 2,
          y: 1,
          onComplete: function onComplete() {
            _gsap.TweenLite.to(scale, 0.2, { x: 0, y: 0 });
          }
        });
      } else {
        _gsap.TweenLite.fromTo(scale, 2, {
          x: isCirclesBig === false ? 2 : 0,
          y: isCirclesBig === false ? 2 : 0
        }, {
          y: isCirclesBig === false ? 12 : targetScale,
          x: isCirclesBig === false ? 12 : targetScale
        });
      }
    }
  }, {
    key: 'initPixi',
    value: function initPixi() {
      var _props2 = this.props,
          isCirclesBig = _props2.isCirclesBig,
          isCircles = _props2.isCircles,
          isPulse = _props2.isPulse;

      var canvas = this.canvas;
      var renderer = this.renderer;
      var stage = this.stage;

      canvas.appendChild(renderer.view);
      stage.interactive = true;

      if (isCirclesBig) {
        this.initCircles(true);
      } else if (isCircles) {
        this.initCircles(false);
      } else if (isPulse) {
        this.initPulse();
      }
      this.animatePixi();
    }
  }, {
    key: 'animatePixi',
    value: function animatePixi() {
      if (this.stage !== null) {
        var stage = this.stage;
        var renderer = this.renderer;

        renderer.render(stage);
        this.mainRAF = window.requestAnimationFrame(this.animatePixi.bind(this));
      }
    }
  }, {
    key: 'initImagePixi',
    value: function initImagePixi() {
      var _props3 = this.props,
          isPulse = _props3.isPulse,
          isCirclesBig = _props3.isCirclesBig,
          isCircles = _props3.isCircles,
          img = _props3.img;

      var canvas = this.canvas;

      var ww = this.state.imgW;
      var hh = this.state.imgH;

      this.renderer = PIXI.autoDetectRenderer(ww, hh, { antialias: true, transparent: true, resolution: 2 });
      this.stage = new PIXI.Container();

      var w = 600;
      var h = 600;

      var stage = this.stage;
      var renderer = this.renderer;

      canvas.appendChild(renderer.view);
      stage.interactive = true;

      if (isPulse) {
        this.displacementSprite = PIXI.Sprite.fromImage('/images/displacement3.png');
      } else if (isCirclesBig) {
        this.displacementSprite = PIXI.Sprite.fromImage('/images/displacement2.jpg');
      } else {
        this.displacementSprite = PIXI.Sprite.fromImage('/images/displacement4.jpg');
      }

      var displacementSprite = this.displacementSprite;
      displacementSprite.width = isCircles ? w * 3 : w;
      displacementSprite.height = h;
      displacementSprite.scale.set(0, isCircles ? 1 : 0);
      if (isPulse) {
        displacementSprite.position.set(500, hh / 2);
      } else {
        displacementSprite.position.set(ww / 2, hh / 2);
      }
      displacementSprite.anchor = {
        x: isCircles ? 1 : 0.5,
        y: 0.5
      };
      displacementSprite.opacity = 0;
      stage.addChild(displacementSprite);
      this.displacementFilter = new PIXI.filters.DisplacementFilter(displacementSprite);
      var displacementFilter = this.displacementFilter;

      var image = PIXI.Sprite.fromImage(img);
      image.position.set(isPulse ? 480 : 0, hh / 2 - 500 / 2);
      image.width = 520;
      image.height = 520;
      image.filters = [displacementFilter];
      stage.addChild(image);

      this.animateImgPixi();
    }
  }, {
    key: 'animateImgPixi',
    value: function animateImgPixi() {
      if (this.stage !== null) {
        this.renderer.render(this.stage);
        this.imgRAF = window.requestAnimationFrame(this.animateImgPixi.bind(this));
      }
    }
  }, {
    key: 'renderIcon',
    value: function renderIcon(icon) {
      switch (icon) {
        case 'network':
          return _react2.default.createElement(_Network2.default, null);
        case 'control':
          return _react2.default.createElement(_Control2.default, null);
        case 'light':
          return _react2.default.createElement(_Light2.default, null);
        case 'solutions':
          return _react2.default.createElement(_Solutions2.default, null);
        default:
          return;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props4 = this.props,
          ltr = _props4.ltr,
          num = _props4.num,
          title = _props4.title,
          img = _props4.img,
          isCirclesBig = _props4.isCirclesBig,
          isPulse = _props4.isPulse,
          isCanvas = _props4.isCanvas,
          icon = _props4.icon;

      var mediaClass = ltr ? _media2.default.media : _media2.default.mediaRtl;

      var canvasClass = isCirclesBig ? _media2.default.canvas : _media2.default.canvasSmall;
      var imgClass = isCanvas ? _media2.default.imgHidden : _media2.default.img;
      var pattern = '';

      if (isCirclesBig) {
        pattern = '/images/creative/big-circles.svg';
      } else if (isPulse) {
        pattern = '/images/creative/pulse.svg';
      } else {
        pattern = '/images/creative/small-circles.svg';
      }

      return _react2.default.createElement(
        'div',
        { className: mediaClass, style: { opacity: this.state.inView ? 1 : 0 }, ref: 'block' },
        _react2.default.createElement(
          'div',
          { className: _media2.default.contentHolder },
          _react2.default.createElement(
            'div',
            { className: _media2.default.num },
            num
          ),
          _react2.default.createElement(
            'h3',
            { className: _media2.default.title },
            title
          ),
          _react2.default.createElement('div', {
            className: _media2.default.copy,
            dangerouslySetInnerHTML: { __html: this.props.children }
          })
        ),
        _react2.default.createElement(
          'div',
          { className: _media2.default.imgHolder, ref: function ref(_ref3) {
              _this4.imgHolder = _ref3;
            } },
          icon && this.renderIcon(icon),
          !icon && _react2.default.createElement(
            'div',
            { className: _media2.default.imgGhost },
            _react2.default.createElement('img', { className: imgClass, src: img, alt: title }),
            _react2.default.createElement('img', { className: _media2.default.pattern, src: pattern, alt: title })
          ),
          !icon && _react2.default.createElement(
            'div',
            { className: _media2.default.canvasHolder },
            _react2.default.createElement('div', {
              className: _media2.default.imgCanvas,
              width: '570',
              height: '570',
              ref: function ref(_ref) {
                _this4.imgCanvas = _ref;
              }
            }),
            _react2.default.createElement('div', {
              className: canvasClass,
              width: this.state.imgW,
              height: this.state.imgH,
              ref: function ref(_ref2) {
                _this4.canvas = _ref2;
              }
            })
          )
        )
      );
    }
  }]);

  return Media;
}(_react.Component);

Media.propTypes = {
  ltr: _react.PropTypes.bool.isRequired,
  num: _react.PropTypes.string,
  title: _react.PropTypes.string.isRequired,
  img: _react.PropTypes.string,
  icon: _react.PropTypes.string,
  isCanvas: _react.PropTypes.bool,
  isCirclesBig: _react.PropTypes.bool,
  isPulse: _react.PropTypes.bool
};

exports.default = Media;


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/Media.js
// module id = 147
// module chunks = 1